import type { StepDefinition } from "../data/schemas.js";
import type { KnowledgeTriggerReason } from "../knowledge/knowledge-engine.js";

export interface HintDecision {
  knowledgeId: string;
  reason: KnowledgeTriggerReason;
}

/** 步骤进入时若声明了 knowledgeRefs，自动带出第一张（对齐"⑥ 形成知识点"）。 */
export function hintOnStepEntered(step: StepDefinition): HintDecision | undefined {
  const knowledgeId = step.knowledgeRefs?.[0];
  return knowledgeId ? { knowledgeId, reason: "step_entered" } : undefined;
}

/** 判断点答错时带出知识卡——不阻塞流程，只是"错了给张卡"（tech/108 §4.6）。 */
export function hintOnWrongAnswer(step: StepDefinition): HintDecision | undefined {
  const knowledgeId = step.knowledgeRefs?.[0];
  return knowledgeId ? { knowledgeId, reason: "wrong_answer" } : undefined;
}

/** 学生主动求助。 */
export function hintOnRequested(step: StepDefinition): HintDecision | undefined {
  const knowledgeId = step.knowledgeRefs?.[0];
  return knowledgeId ? { knowledgeId, reason: "hint_requested" } : undefined;
}
